import { CheckboxPropertiesType } from "@website/ui/checkbox/checkbox.types";
import pick from "lodash-es/pick";
import { useEffect, useRef } from "react";

export const useCheckbox = (properties: CheckboxPropertiesType) => {
  const { indeterminate } = properties;
  const inputReference = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (indeterminate && inputReference.current) {
      inputReference.current.indeterminate = true;
    }
  }, [indeterminate]);

  return {
    inputProps: {
      ...pick(
        properties,
        "autoFocus",
        "disabled",
        "checked",
        "name",
        "onChange",
        "readOnly",
        "value"
      ),
      type: "checkbox",
      ref: inputReference
    }
  };
};
